export const validateLinkParamValue = (val: string | undefined | null) => {
  if (!val) return true;
  return /^[A-Za-z0-9-()[\]]*$/.test(val);
};

export function validateQueryParamValue(val: string) {
  return /^[A-Za-z0-9_]*$/.test(val);
}

export function validateTagName(val: string) {
  return /^[A-Za-z0-9-]*$/.test(val);
}
